import { Box, Button, Typography, makeStyles } from '@material-ui/core';

import { ImpressionTracker } from '@spotify/plugin-confidence-tracking-react';

import { Branding } from './CreateAccountForm';
import UnavailableMarket from './img/unavailable_market.png';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    height: '100vh',
    width: '100vw',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    zIndex: theme.zIndex.modal,
  },
  content: {
    textAlign: 'center',
    maxWidth: 520,
    display: 'flex',
    gap: theme.spacing(6),
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  image: {
    objectFit: 'contain',
  },
  title: {
    lineHeight: '2.5rem',
    marginBottom: theme.spacing(1),
  },
}));

export const UnsupportedMarketPage = ({
  onNotifyMe,
}: {
  onNotifyMe: () => void;
}) => {
  const classes = useStyles();

  return (
    <>
      <Branding />
      <ImpressionTracker elementId="region.unsupported-market">
        <Box className={classes.container}>
          <Box className={classes.content}>
            <img
              className={classes.image}
              src={UnavailableMarket}
              alt=""
              width="300"
            />
            <div>
              <Typography variant="h4" className={classes.title}>
                We're not in your country just yet, but don't worry!
              </Typography>
              <Typography variant="body1">
                We are working on expanding Confidence to more countries. Click
                'Notify Me' so you can be the first to know when we make it to
                your country.
              </Typography>
            </div>
            <Button
              variant="contained"
              data-testid="continue"
              onClick={onNotifyMe}
              color="primary"
            >
              Notify me
            </Button>
          </Box>
        </Box>
      </ImpressionTracker>
    </>
  );
};
